module.exports = __webpack_public_path__ + "static/img/weatherFullWeb.35a55072.webp";